import { faEdit } from "@fortawesome/pro-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { clsx } from "clsx";

import { T } from "@repo/transifex";

export type CollectSummaryOrderLine = {
  name: string;
  quantity: number;
};

type CollectSummaryProps = {
  orderLines: CollectSummaryOrderLine[];
};

export const CollectSummary = ({ orderLines }: CollectSummaryProps) => {
  return (
    <div className="w-full rounded-xl bg-interface-warning-1 px-4 py-5 text-interface-neutral-6">
      <div className="flex items-center justify-between">
        <p className="text-lg font-bold">
          <T _str="Active Basket" />
        </p>

        <FontAwesomeIcon icon={faEdit} className="text-interface-neutral-5" />
      </div>

      <div className="flex flex-col">
        {orderLines.map((orderLine, index) => (
          <div
            key={orderLine.name}
            className={clsx("flex items-center justify-between pt-5 text-lg", {
              "border-b border-interface-neutral-3 pb-5":
                index !== orderLines.length - 1
            })}
          >
            <p className="text-lg">
              {orderLine.quantity} {orderLine.name}
            </p>
          </div>
        ))}
      </div>
    </div>
  );
};

const Banner = () => {
  return (
    <div className="flex w-full items-center justify-between rounded-xl bg-interface-neutral-2 px-4 py-5 text-interface-neutral-6">
      <p className="text-lg font-bold">
        <T _str="Tap to view Pre-order details" />
      </p>
      <FontAwesomeIcon icon={faEdit} className="text-interface-neutral-5" />
    </div>
  );
};

CollectSummary.Banner = Banner;

const Skeleton = () => {
  return (
    <div className="h-20 w-full animate-pulse rounded-xl bg-interface-neutral-2 outline outline-1 outline-white" />
  );
};

CollectSummary.Skeleton = Skeleton;
